import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Context } from '../../Store/store';
import { devLog, overlay } from '../../utils/Helper';
import HttpRequest from '../../Services/HttpRequest';
import FlashMessage from '../FlashMessage/index';
import ApiRoutes from '../../Services/ApiRoutes';


export default function NAVerificationCode({ submitForm }){
    const [state, dispatch] = React.useContext(Context);

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.target;
        let params = new FormData(form);
        submitForm(params);
    }

    // const handleResend = () => {
    //     dispatch({type: "SET_STATE", response: [], flash_message_show: false});
    //     overlay(true);
    //     // const payload = {type:}
    //     const params = new FormData();
    //     params.append('type','registration');
    //     HttpRequest.makeRequest(
    //         ApiRoutes.resendVerificationCode.method,
    //         ApiRoutes.resendVerificationCode.end_point,
    //         params)
    //         .then((response) => {
    //         if(response.resCode === 200){
    //             overlay(false);
    //             dispatch({type:'SET_STATE', response: response, flash_message_show: true});
    //         }else{
    //             dispatch({type:'SET_STATE', response: response, flash_message_show: true})
    //             overlay(false);
    //         }
    //     }).catch(err=>{
    //         devLog("error",err);
    //     });
    // };

    return(
        <>
            <Helmet>
                <title>Consent - Verification Code</title>
            </Helmet>
            <div className="rg-maincontainer">

                <main className="rg-form">
                    <form onSubmit={handleSubmit}>
                        <input type="hidden" value="forget_password" name="type" />
                        <Link to="/home">
                            <img 
                                className="login-header-img fp-header-img" 
                                src="./assets/images/loginheader.png" 
                                alt=" Main Logo " 
                                width="72" 
                                height="57"
                            />
                        </Link>
                        <FlashMessage />
                        <h1 className="rg-form-heading fp-specialfont">Verifcation Code</h1>
                        <p className="rg-form-para">We have sent you a 4 Digit Verification Code
                            On your Phone.</p>

                        <div className="rg-form-floating">
                            <label htmlFor="floatingInput">Please enter the code to Proceed.</label>
                            <input 
                                type="text" 
                                className="rg-formcontrol rg-mbpass" 
                                id="floatingInput"
                                name="code" 
                            />  
                            {/* <p className="rc-resendcode ">Didn’t get the Code? <a  href="#" onClick={handleResend}> Resend Code</a> </p>               */}
                        </div>
                        
                        <button className="rg-formbutton lg-btnmargin" type="submit">Submit</button>
                        

                    </form>
                </main>   

            </div>
        </>
    );
    };